// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewMessagesBadge__container-bc01f4 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: solid 2px var(--base-0);
  background-color: var(--brand-primary-40);
}`, "",{"version":3,"sources":["webpack://./src/main/SidebarPanel/SidebarPanelNavigation/NewMessagesBadge/NewMessagesBadge.styles.m.css"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,+BAAA;EACA,yCAAA;AACF","sourcesContent":[".container {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  border: solid 2px var(--base-0);\n  background-color: var(--brand-primary-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewMessagesBadge__container-bc01f4`
};
module.exports = ___CSS_LOADER_EXPORT___;
